import type { CampaignStatus } from '~/types/graphql';

import { GCampaignBadge } from '~/presentation/common';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useMemo } from 'react';

export interface StatusPropertyProps {
  status?: CampaignStatus;
}

export const StatusProperty: React.FC<StatusPropertyProps> = ({ status }) => {
  const campaignStatus = useMemo(() => status ?? CAMPAIGN_STATUS.DRAFT, [status]);

  return (
    <div className="flex items-center justify-end w-full">
      <GCampaignBadge status={campaignStatus} />
    </div>
  );
};
